import axios from 'axios';

const updateAgent = params => {
  return axios.put(`tickets/ubidesk/agents/me`, params);
};

export { updateAgent };
